export default "__VITE_ASSET__DA8dr75O__"